"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
var _APIcon = _interopRequireDefault(require("../APIcon"));
require("./APIconButton.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/* eslint-disable react/no-unknown-property */

var APIconButton = function APIconButton(props) {
  var tooltipText = props.tooltipText,
    iconName = props.iconName,
    customClass = props.customClass,
    action = props.action,
    showLabel = props.showLabel,
    tooltipPosition = props.tooltipPosition,
    label = props.label,
    isDisabled = props.isDisabled;
  var baseClass = 'icon-button';
  var bemClasses = (0, _cssClassesHelper.getBEMClasses)(baseClass, customClass);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    tooltip: tooltipText ? tooltipText : null,
    "tooltip-position": tooltipPosition,
    role: "button",
    onClick: action,
    className: "".concat(bemClasses(null, isDisabled ? 'disabled' : ''))
  }, /*#__PURE__*/_react["default"].createElement(_APIcon["default"], {
    name: iconName,
    customClass: bemClasses('icon')
  }), showLabel && /*#__PURE__*/_react["default"].createElement("span", {
    className: bemClasses('label')
  }, label || iconName)));
};
APIconButton.defaultProps = {
  showLabel: true,
  tooltipPosition: 'top'
};
APIconButton.protoTypes = {
  iconName: _propTypes["default"].string.isRequired,
  parentClass: _propTypes["default"].string.isRequired,
  tooltipPosition: _propTypes["default"].string,
  tooltipText: _propTypes["default"].string,
  action: _propTypes["default"].func,
  showLabel: _propTypes["default"].bool,
  label: _propTypes["default"].string
};
var _default = exports["default"] = APIconButton;